import styled from 'styled-components';
import SidebarComponent from '@/components/Sidebar';

export const PageGrid = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    flex-direction: row;
  }
`;

export const Content = styled.div`
  & > div:first-of-type {
    z-index: 1;
  }
  width: 100%;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: calc(100% - 300px);
  }
`;

export const Table = styled.table`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.colors['neutral-100']};
  width: 100%;

  tr {
    border-bottom: 1px solid ${({ theme }) => theme.colors['neutral-30']};
  }

  thead td {
    color: ${({ theme }) => theme.colors['neutral-80']};
    padding: 7.5px 0;
  }

  tbody td {
    padding: 15.5px 0 7.5px;
  }

  &:last-child tbody tr {
    border-bottom: 0 none;
  }
`;

export const Sidebar = styled(SidebarComponent)`
  top: 67px;
`;
